import { client } from "utils";

export const getTenantsRequest = () => client.get("tenants");
